export default "/images/brand1.png?21239b2501378fc99b80bc982eccefcc";